import React, { Suspense, useMemo } from "react";
import { Route, Routes } from "react-router-dom";

// Layouts
import VerticalLayout from "../Layouts";
import NonAuthLayout from "../Layouts/NonAuthLayout";

// Components
import BrandPageLoader from "Components/Common/PageSkeleton/BrandPageLoader";
import ErrorBoundary from "../Components/Common/ErrorBoundary/ErrorBoundary";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected from "./AuthProtected";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

// ✅ 1. Import Hook aur Offline Component
// import { useOnlineStatus } from "../hooks/useOnlineStatus";
import OfflinePage from "pages/Authentication/OfflinePage";
import { useOnlineStatus } from "Components/Hooks/useOnlineStatus";

// 404 Component
const Error404 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Basic404"));

const getRouteKey = route => {
  return route.path || `route-${Math.random()}`;
};

const LazyPageWrapper = ({ component, loaderType = "general", showLoader = true }) => {
  return (
    <Suspense
      fallback={showLoader ? <BrandPageLoader className="page-content" cmpName="" /> : null}
    >
      {component}
    </Suspense>
  );
};

const Index = () => {
  // ✅ 2. Network status check karein
  const isOnline = useOnlineStatus();

  // Public routes
  const publicRoutesElements = useMemo(
    () =>
      publicRoutes.map(route => (
        <Route
          key={getRouteKey(route)}
          path={route.path}
          element={
            <PublicRoute>
              <NonAuthLayout>
                <LazyPageWrapper component={route.component} loaderType={route.loaderType} />
              </NonAuthLayout>
            </PublicRoute>
          }
        />
      )),
    [],
  );

  // Protected routes
  const protectedRoutesElements = useMemo(
    () =>
      authProtectedRoutes.map(route => (
        <Route
          key={getRouteKey(route)}
          path={route.path}
          element={
            <AuthProtected>
              <ProtectedRoute
                permission={route.permission}
                permissions={route.permissions}
                requireAll={route.requireAll}
                roleLevel={route.roleLevel}
              >
                <VerticalLayout>
                  <LazyPageWrapper component={route.component} loaderType={route.loaderType} />
                </VerticalLayout>
              </ProtectedRoute>
            </AuthProtected>
          }
        />
      )),
    [],
  );

  // 404 Route
  const notFoundRoute = useMemo(
    () => (
      <Route
        key="404"
        path="*"
        element={
          <NonAuthLayout>
            <LazyPageWrapper component={<Error404 />} loaderType="general" />
          </NonAuthLayout>
        }
      />
    ),
    [],
  );

  return (
    <ErrorBoundary>
      {/* ✅ 3. Agar internet disconnected hai, to turant OfflinePage display hoga */}
      {!isOnline && <OfflinePage />}

      <Routes>
        {publicRoutesElements}
        {protectedRoutesElements}
        {notFoundRoute}
      </Routes>
    </ErrorBoundary>
  );
};

export default Index;
